// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.k-form .dataCaptureSection {
  background-color: #f8f7f3;
}
.k-form .dataCaptureSection .arrayItem .editIcon,
.k-form .dataCaptureSection .arrayItem .deleteIcon {
  background-color: initial;
  position: initial;
  float: right;
  margin: 0;
}
.k-form .dataCaptureSection .arrayItem .editIcon img,
.k-form .dataCaptureSection .arrayItem .deleteIcon img {
  position: initial;
  width: 24px;
}
.k-form .dataCaptureSection .arrayItem p {
  display: inline-block;
}
.k-form .dataCaptureSection .arrayItem .sectionContainer .address {
  width: calc(100% - 64px);
}
.k-form .dataCaptureSection .arrayItem .itemDetail {
  max-width: 190px;
  font-size: 15px;
}
.k-form .dataCaptureSection .arrayItem .sectionContainer {
  padding-left: 32px;
  padding-right: 32px;
}
.k-form .dataCaptureSection .arrayItem .sectionContainer div {
  text-align: center;
}
.k-form .dataCaptureSection .arrayItem .sectionContainer .actionButtons {
  width: 100%;
  text-align: right;
}
.k-form .dataCaptureSection .arrayItem .sectionContainer .actionButtons button {
  margin-top: 0;
  margin-bottom: 0;
}
.k-form .dataCaptureSection .arrayItem .sectionContainer.expanded {
  padding-left: 17px;
  padding-right: 17px;
}
@media (max-width: 845px) {
  .k-form .dataCaptureSection .arrayItem .sectionContainer.expanded {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 846px) {
  .k-form .dataCaptureSection .arrayItem .sectionContainer .actionButtons {
    width: calc(100% - 34px);
  }
  .k-form .dataCaptureSection .arrayItem .itemDetail {
    max-width: 600px;
  }
}
@media (max-width: 599px) {
  .k-form .dataCaptureSection .arrayItem .sectionContainer.expanded {
    padding-left: 0;
    padding-right: 0;
  }
  .k-form .dataCaptureSection::after {
    content: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/ArrayEditor.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EACC,yBAAA;AAYD;AAbA;;EAMG,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;AAWH;AApBA;;EAWI,iBAAA;EACA,WAAA;AAaJ;AAzBA;EAgBG,qBAAA;AAYH;AA5BA;EAqBI,wBAAA;AAUJ;AA/BA;EA0BG,gBAAA;EACA,eAAA;AAQH;AAnCA;EAgCE,kBAAA;EACA,mBAAA;AAMF;AAvCA;EAoCG,kBAAA;AAMH;AA1CA;EAuCG,WAAA;EACA,iBAAA;AAMH;AA9CA;EA0CI,aAAA;EACA,gBAAA;AAOJ;AAlDA;EAiDE,kBAAA;EACA,mBAAA;AAIF;AAFE;EAAA;IACC,eAAA;IACA,gBAAA;EAKD;AACF;AAFC;EAAA;IAGG,wBAAA;EAGF;EAND;IAOG,gBAAA;EAEF;AACF;AAEC;EAAA;IAEE,eAAA;IACA,gBAAA;EAAD;EAGA;IACC,aAAA;EADD;AACF","sourcesContent":["@import '../../constants.less';\n\n.k-form .dataCaptureSection {\n\tbackground-color: @fieldBackgroundWhite;\n\n\t.arrayItem {\n\t\t.editIcon,\n\t\t.deleteIcon {\n\t\t\tbackground-color: initial;\n\t\t\tposition: initial;\n\t\t\tfloat: right;\n\t\t\tmargin: 0;\n\t\t\timg {\n\t\t\t\tposition: initial;\n\t\t\t\twidth: 24px;\n\t\t\t}\n\t\t}\n\t\tp {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t.sectionContainer {\n\t\t\t.address {\n\t\t\t\twidth: calc(100% - 64px);\n\t\t\t}\n\t\t}\n\n\t\t.itemDetail {\n\t\t\tmax-width: 190px;\n\t\t\tfont-size: 15px;\n\t\t}\n\t}\n\n\t.arrayItem .sectionContainer {\n\t\tpadding-left: 32px;\n\t\tpadding-right: 32px;\n\n\t\tdiv {\n\t\t\ttext-align: center;\n\t\t}\n\t\t.actionButtons {\n\t\t\twidth: 100%;\n\t\t\ttext-align: right;\n\t\t\tbutton {\n\t\t\t\tmargin-top: 0;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t.arrayItem .sectionContainer.expanded {\n\t\tpadding-left: @dataCaptureContainerPadding;\n\t\tpadding-right: @dataCaptureContainerPadding;\n\n\t\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n\n\t@media (min-width: @dataCaptureTwoColumnFieldsPageMinWidth) {\n\t\t.arrayItem {\n\t\t\t.sectionContainer .actionButtons {\n\t\t\t\twidth: calc(100% - 34px);\n\t\t\t}\n\n\t\t\t.itemDetail {\n\t\t\t\tmax-width: 600px;\n\t\t\t}\n\t\t}\n\t}\n\n\t@media (max-width: @phoneOnlyMaxWidth) {\n\t\t.arrayItem .sectionContainer.expanded {\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\n\t\t&::after {\n\t\t\tcontent: none;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
